/** 历史记录变化 */
export const HISTORY_CHANGE_EVENT = 'history-change';
/** 历史记录变化之前 */
export const HISTORY_BEFORE_CHANGE_EVENT = 'history-before-change';
/** 历史记录写入之后 */
export const HISTORY_AFTER_WRITE_EVENT = 'history-after-write';
